import React, { Component } from 'react';
import ReactPlayer from 'react-player/lazy';
import { Button } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Skeleton } from '@material-ui/lab';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { withRouter, Redirect } from "react-router";  

class VideoPlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            canPlay: false,
            isReady: false,
        };
    }

    componentDidUpdate(prevProps){
        if (this.props.selectedVideo) {
            document.title = `Pupitres | Video: ${this.props.selectedVideo.title}`
        }
    }

    componentDidMount() { }

    componentWillUnmount(){
        if (!this.props.selectedVideo) {
            toast.error("Video no encontrado")
        }
        this.props.selectVideo(null);
    }

    handlePlay = () => { }

    handlePause = () => { }

    handleReady = () => {
        this.setState({ isReady: true });
    }

    handleError = () => {
        toast.error("Ha ocurrido un error al cargar el video seleccionado.");
    }

    ref = player => {
        this.player = player;
    }

    handleEnded = () => { }

    render() {
        const { selectedVideo } = { ...this.props };
        const { canPlay, isReady } = this.state;

        if (!selectedVideo) {
            const { id } = this.props.match.params;
            const m = this.props.findVideos(this.props.menu, []);
            for (let i = 0; i < m.length; i++) {
                let video = m[i];
                if (video["video"]["id"]) {
                    if (video["video"]["id"] === id) {
                        this.props.selectVideo(video);
                        return <></>
                    }
                }
            }

            if (this.props.selectedVideo) {
                document.title = "Pupitres | " + this.props.selectedVideo.title;

                let canPlay = ReactPlayer.canPlay(this.props.selectedVideo.url);

                this.setState({ canPlay });
            }
        }

        return (
            <>
                {
                    !isReady && canPlay && selectedVideo ?
                        <div className="player-wrapper"><Skeleton data-transform="none" height="70vh" width="65vw"></Skeleton></div>
                        :
                        ""
                }

                {
                    selectedVideo ?
                        <>
                            <ReactPlayer
                                ref={this.ref}
                                className="react-player"
                                controls={true}
                                url={selectedVideo.url}
                                config={{
                                    youtube: {
                                        playerVars: { showInfo: 1 }
                                    },
                                    embedOptions: {
                                        height: '100%',
                                        width: '100%'
                                    }
                                }}
                                //style={isReady ? { display: "inherit" } : { display: "none" }}
                                style={{}}
                                onPlay={this.handlePlay}
                                onPause={this.handlePause}
                                onError={this.handleError}
                                onReady={this.handleReady}
                                onEnded={this.handleEnded}
                            />
                            {/*<Row className="mt-3 player-wrapper-buttons">
                                <Col style={{ textAlign: "center" }}>
                                    <Button className="btn btn-black" onClick={() => { }} ><h5>Anterior</h5></Button>
                                </Col>
                                <Col style={{ textAlign: "center" }}>
                                    <Button className="btn btn-black" onClick={() => { }} ><h5>Siguiente</h5></Button>
                                </Col>
                            </Row>*/}
                        </>
                        :
                        !isReady && canPlay ?
                            ""
                            :
                            !canPlay && !isReady && !selectedVideo ? <Redirect from="*" to={process.env.PUBLIC_URL + "/"} /> : ""

                }
                {/*<Button variant="primary" onClick={() => this.player.seekTo(parseFloat(4.5))}>Seek</Button>*/}
            </>
        )
    }
}

export default withRouter(VideoPlayer);